import { Box, Dialog, DialogContent, IconButton } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../Redux/Reducers";
import {
  addToCart,
  isCreateBillModalVisible as isCreateBillModalVisibleAction,
  saveOrderInfo,
} from "../../Redux/Actions";
import CloseIcon from "../../Assets/images/black-close-icon.png";
import BillSuccessImg from "../../Assets/images/billSuccessImg.png";
import { useStyles } from "./style";
import { CURRENCY_SYMBOL } from "../../Config";
import moment from "moment";
import { useEffect } from "react";

const CreateBillSuccessModal = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { isCreateBillModalVisible, cartData, orders } = useSelector((state: RootState) => ({
    isCreateBillModalVisible: state.commonReducer.isCreateBillModalVisible,
    cartData: state.cartReducer.data,
    orders: state.ordersReducer,
  }));

  const onClose = () => {
    dispatch(addToCart({ items: [] }));
    dispatch(
      saveOrderInfo({
        orderId: "",
        customerName: "",
        customerPhone: "",
        timeStamp: "",
      }),
    );
    dispatch(isCreateBillModalVisibleAction(false));
  };

  return (
    <Dialog open={isCreateBillModalVisible} maxWidth="xs" fullWidth={true} onClose={onClose} className="relative">
      <IconButton
        color="primary"
        aria-label="Close Order Details Pop Up"
        component="span"
        className={classes.closeIcon}
        onClick={onClose}
      >
        <img src={CloseIcon} alt="close icon" loading="lazy" className="img h2" />
      </IconButton>
      <DialogContent>
        <Box className="flex justify-center mv2 center" component="section">
          <img src={BillSuccessImg} width="200" />
        </Box>
        <Box className="flex justify-center black-80 f5">
          {/* @ts-ignore */}
          Your bill is sent to {orders?.billItemInfo?.customerPhone}
        </Box>
        <Box
          className="mv3 pv3 center bt bb b--light-gray"
          style={{
            borderStyle: "dashed",
            maxWidth: 350,
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="1rem">
            <Box display="flex" flexDirection="column">
              <Box component="p" className="ttu gray mv0">
                Date
              </Box>
              <Box component="p" className="black-80 mv0 ttu f6">
                {moment(new Date()).format("D, MMM YYYY")}
              </Box>
            </Box>
            <Box display="flex" flexDirection="column">
              <Box component="p" className="ttu gray mv0 tr">
                Time
              </Box>
              <Box component="p" className="black-80 mv0 tr ttu f6">
                {moment(new Date()).format("hh:mm A")}
              </Box>
            </Box>
          </Box>

          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" flexDirection="column">
              <Box component="p" className="ttu gray mv0">
                To
              </Box>
              <Box component="p" className="black-80 mv0 f6">
                {/* @ts-ignore */}
                {orders?.billItemInfo?.customerPhone}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          className="mv3 pv3 center"
          style={{
            maxWidth: 350,
          }}
        >
          <Box display="flex" justifyContent="space-between" className="ttu gray mv0 tr">
            Amount
          </Box>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box component="p" className="mv0 f4 fw5">
              {CURRENCY_SYMBOL}
              {cartData?.pay_amount?parseFloat(cartData.pay_amount.toFixed(2)):0}
            </Box>
            <Box component="p" className="mv0 f6 gray f6">
              {/* @ts-ignore */}
              ID: {orders?.billItemInfo?.orderId}
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CreateBillSuccessModal;
